import React, { createContext, useContext } from "react";

// Création du contexte
const DirectContext = createContext(null);

// Hook pour accéder facilement au contexte
export const useDirect = () => useContext(DirectContext);

// Provider pour envelopper l'application
export const DirectProvider = ({ directEvent, children }) => {
  return <DirectContext.Provider value={directEvent}>{children}</DirectContext.Provider>;
};